import React, { Component, useState, useEffect, useRef, useCallback } from "react";
import 'viewerjs/dist/viewer.css';
import Viewer from  'viewerjs';
import { getChannel } from "postal";

const postal = getChannel('ucs');



function PictureViewer (props) {
    const {
        src,
        name,
        sizeChange,
        ...other
    } = props;

    const [iviewer, setIviewer] = useState(null);

    /*
    useEffect( () => {
        const resizeUnsub = postal.subscribe(
            'app.catalog.viewer.resize',
            (envelope) => {
                // console.log('PictureViewer enter resizing...' + iviewer);
                // window.dispatchEvent(new Event('resize'));
                if ( iviewer ) {
                    console.log('PictureViewer1 resizing...');
                    iviewer.resize();
                }
            }
        );
        return () => {
            resizeUnsub();
        };
    },[]);
    */

    useEffect(() => {
        // console.log('PictureViewer enter resizing...' + iviewer);
        // viewerjs responds to window resize events
        window.dispatchEvent(new Event('resize'));
        if ( iviewer ) {
            // console.log('PictureViewer2 resizing...');
            iviewer.resize(); // this doesn't seem to have any effect
        } 
    },[sizeChange]);

    const handleIviewerInit = (node) => {
        const v = new Viewer(node, {
            inline: true,
            backdrop: false,
            button: false,
            navbar: false,
            fullscreen: false,
            toolbar: {
                zoomIn: 1,
                zoomOut: 1,
                oneToOne: 1,
                reset: 1,
                prev: 0,
                play: 0,
                next: 0,
                rotateLeft: 1,
                rotateRight: 1,
                flipHorizontal: 1,
                flipVertical: 1,
            },
            title: (image, imageData) => `${name} (${imageData.naturalWidth} × ${imageData.naturalHeight})`,
            viewed() {
                if (iviewer) {
                    iviewer.zoomTo(1);
                } else if (v) {
                    v.zoomTo(1);
                }
            },
        });
        setIviewer(v);
    };

    const imageRef = useCallback(node => {
        if (node !== null) {
            // Node is ready; perform calculations or setup here
            handleIviewerInit(node);
        }
    }, []);

    return (
        <div style={{width: '100%', height: '100%'}}>
            <img src={src} ref={imageRef} style={{visibility: 'hidden'}} />
        </div>
    );
}

export { PictureViewer };